import {CSSProperties} from "react";
import {getCssVar} from "@web-libs/features/colors/application/colors";
import {Text} from "@web-libs/ui/ui-components/typo/text";

type TabProps = {
    name: string
    active?: boolean
    onClick?: () => void
    style?: CSSProperties
}
export const Tab = (props: TabProps) => {
    const _active = props.active ?? false;
    const _style: CSSProperties = {
        padding: "15px 20px",
        backgroundColor: _active ? getCssVar("primary") : getCssVar("lightShade"),
        color: _active ? getCssVar("light") : getCssVar("unobtrusive"),
        borderRadius: 10,
        cursor: "pointer",
        ...props.style
    }

    return (
        <div onClick={props.onClick} style={_style}>
            <Text>{props.name}</Text>
        </div>
    )
}
